import $ from 'jquery';
import 'chosen-js';
import 'chosen-js/chosen.css';
import {usgaUtils} from '../../js/usga.utils';
import {LeaderBoardBaseControl} from '../leaderboard-base/leaderboard-base';
import {LeaderBoardTickerModel} from './leaderboard-ticker-model';
import {LeaderboardTickerContentControl} from './leaderboard-ticker-content';
import leaderBoardTickerTabs from './leaderboard-ticker-tabs.stache';
import leaderBoardTickerDropdown from './leaderboard-ticker-dropdown.stache';
import appContext from 'scripts/app-context';
import dtm from 'scripts/services/dtm';

export const LeaderboardTickerControl = LeaderBoardBaseControl.extend({
	tabs: null,
	dropdown: null,
	currentLeaderBoard: null,
	currentLeaderBoardData: null,
	init: function () {
		this._super();
		this.updateIntervalDuration = this.tickerUpdateIntervalDuration;
		this.context = new LeaderBoardTickerModel();
		this.context.attr('screenSize', this.getScreenSize());
		this.dataUrl = this.options.tickerUrl;
		this.hideTicker();
		this.render();
		this.getData();
	},
	render: function () {
		this.element.append(leaderBoardTickerTabs(this.context, this.getHelpers()));
		this.renderDropdown();
	},
	renderDropdown: function () {
		if (this.tabsElement) {
			this.destroyDropdown();
		}
		this.tabsElement = this.element.find('.s-team-selection')
			.append(leaderBoardTickerDropdown(this.context, this.getHelpers()));
		this.initCustomSelect();
	},
	destroyDropdown () {
		this.tabsElement.empty();
		this.tabsElement = null;
	},
	applyInitialContextData: function (data) {
		if (data && data.items && data.items.length) {
			this.tabs = data.items;
			this.applyTabs();
		}
		this.initDataUpdating();
	},
	applyDataChanges: function (data) {
		if (data && data.items && data.items.length) {
			if (this.checkTabsChanges(data.items)) {
				this.tabs = data.items;
				this.applyTabs();
			}
		}
	},
	applyTabs: function () {
		this.context.tabs.splice(0);
		const ii = this.tabs.length;
		for (let i = 0; i < ii; i++) {
			const tab = this.tabs[i];
			const now = usgaUtils.getMomentInNewYorkTimezone().valueOf();
			const endDate = usgaUtils.getMomentInNewYorkTimezone(tab.endDate).valueOf();
			const startDate = usgaUtils.getMomentInNewYorkTimezone(tab.startDate).valueOf();
			if (startDate <= now && now < endDate) {
				this.context.tabs.push(tab);
			}
		}
		if (this.context.tabs.attr('length') > 0) {
			this.showTicker();
			let currentTab = this.findCurrentTab();
			if (!currentTab) {
				currentTab = this.context.tabs.attr(0);
			}
			this.currentLeaderBoardData = currentTab;
			if (this.dropdown) {
				this.dropdown.trigger('chosen:updated');
			} else {
				this.initCustomSelect();
			}
			this.showLeaderBoard();
		} else {
			this.clearTicker();
		}
	},
	findCurrentTab: function () {
		const id = this.currentLeaderBoardData ? this.currentLeaderBoardData.id : null;
		if (!id) {
			return;
		}
		const tabs = this.context.tabs;
		for (let i = 0; i < tabs.length; i++) {
			const tab = tabs[i];
			if (tab.id === id) {
				return tab;
			}
		}
	},
	handleError: function (xhr) {
		this.clearTicker();
		window.setTimeout(this.proxy(function () {
			this.getData();
		}), this.updateIntervalDuration);
	},
	showTicker: function () {
		$('body').addClass('leaderboard-live-ticker');
		$('.m-navigation').addClass('m-navigation--live');
		$('.m-navigation-placeholder').addClass('m-navigation-placeholder--live');
		this.element.show();
	},
	hideTicker: function () {
		this.element.hide();
		$('body').removeClass('leaderboard-live-ticker');
		$('.m-navigation').removeClass('m-navigation--live');
		$('.m-navigation-placeholder').removeClass('m-navigation-placeholder--live');
	},
	clearTicker: function () {
		this.tabs = null;
		if (this.context.attr('tabs')) {
			this.context.tabs.splice(0);
		}
		this.currentLeaderBoardData = null;
		this.destroyLeaderboard();
		this.hideTicker();
	},
	configureDropdown: function () {
		const isChosen = this.context.attr('isChosen');
		let navigation = $('.m-navigation');
		let navigationPlaceholder = $('.m-navigation-placeholder');
		if (isChosen) {
			navigation.removeClass('m-navigation--native');
			navigationPlaceholder.removeClass('m-navigation-placeholder--native');
		} else {
			navigation.addClass('m-navigation--native');
			navigationPlaceholder.addClass('m-navigation-placeholder--native');
		}
	},
	clearTickerOnExpiredLiveEvents: function () {
		let allEventsAreExpired = true;

		const ii = this.tabs !== null ? this.tabs.length : 0;
		for (let i = 0; i < ii; i++) {
			const tab = this.tabs[i],
				now = usgaUtils.getMomentInNewYorkTimezone().valueOf(),
				endDate = usgaUtils.getMomentInNewYorkTimezone(tab.endDate).valueOf(),
				startDate = usgaUtils.getMomentInNewYorkTimezone(tab.startDate).valueOf();

			if (startDate <= now && now < endDate) {
				allEventsAreExpired = false;
				break;
			}
		}
		if (allEventsAreExpired) {
			this.clearTicker();
			this.stopUpdateInterval();
		}
	},
	showLeaderBoard: function () {
		this.destroyLeaderboard();
		this.currentLeaderBoard = new LeaderboardTickerContentControl('#tickerContent', {
			context: this.context,
			leaderBoardConfig: this.currentLeaderBoardData
		});
	},
	destroyLeaderboard: function () {
		if (this.currentLeaderBoard) {
			this.currentLeaderBoard.destroy();
			this.currentLeaderBoard = null;
		}
	},
	checkTabsChanges: function (newTabs) {
		if (this.tabs === null) {
			return true;
		} else if (this.tabs.length !== newTabs.length) {
			return true;
		} else {
			const ii = this.tabs.length;
			for (let i = 0; i < ii; i++) {
				const tab = this.tabs[i];
				const newTab = newTabs[i];
				for (let prop in tab) {
					if (tab.hasOwnProperty(prop)) {
						if (!newTab[prop] || tab[prop] !== newTab[prop]) {
							return true;
						}
					}
				}
				const now = usgaUtils.getMomentInNewYorkTimezone().valueOf();
				const endDate = usgaUtils.getMomentInNewYorkTimezone(tab.endDate).valueOf();
				const startDate = usgaUtils.getMomentInNewYorkTimezone(tab.startDate).valueOf();
				if (startDate > now || now > endDate) {
					return true;
				}
			}
			return false;
		}
	},
	initCustomSelect: function () {
		if (appContext.model.screen.screenSize === 'extra-large') {
			this.dropdown = this.element.find('.ticker-dropdown').chosen({
				disable_search: true,
				width: '100%'
			});
			// fixes problem on iOS device when keyboard panel is showing
			this.element.find('.chosen-search').remove();
		} else {
			this.context.attr('isChosen', false);
		}
		this.configureDropdown();
	},
	onLayout: function () {
		this.context.attr('screenSize', this.getScreenSize());
		this.renderDropdown();
	},
	onDataUpdated: function () {
		this.clearTickerOnExpiredLiveEvents();
	},
	'.ticker-dropdown chosen:ready': function () {
		this.context.attr('isChosen', true);
		this.element.find('.ticker-dropdown').trigger('chosen:updated');
		this.configureDropdown();

	},
	'.ticker-dropdown change': function (element) {
		const dataIndex = Number(element.val());
		this.currentLeaderBoardData = this.context.tabs.attr(dataIndex);
		this.context.attr('selectedTabIndex', dataIndex);
		this.showLeaderBoard();

		if (!this.element.find('.chosen-container').length) {
			const championshipName = this.currentLeaderBoardData.name.trim().toLowerCase();
			dtm.trackGlobalNavigationTickerChampionshipSelectorClick(championshipName);
		}
	},
	'.chosen-container, .ticker-dropdown click': function (element, event) {
		const championshipName = this.currentLeaderBoardData.name.trim().toLowerCase();
		dtm.trackGlobalNavigationTickerChampionshipSelectorClick(championshipName);
	},
	'.s-right-cta .s-right-cta-button click': function () {
		const championshipName = this.currentLeaderBoardData.name.trim().toLowerCase();
		dtm.trackGlobalNavigationTickerChampionshipScoringClick(championshipName);
	},
	'.s-team-selection .s-marker-live click': function (element, event) {
		const championshipName = this.currentLeaderBoardData.name.trim().toLowerCase();
		dtm.trackGlobalNavigationTickerChampionshipWatchClick(championshipName);
		window.location = element[0].href;
	},
	/**
	 * Fixes problem on iOS device when keyboard panel is showing
	 * See https://jira.omnigon.com/browse/USGAM-99
	 * @param element
	 */
	'.ticker-dropdown chosen:hiding_dropdown': function (element) {
		setTimeout(this.proxy(function () {
			if (this.element.has($(document.activeElement))) {
				$(document.activeElement).blur();
			}
		}, 250));
	}
});
